import Button from '@material-ui/core/Button';
import React, { useMemo } from 'react';
import { themeButtons } from '../../../css/themeButtons';
import { useLocation } from "react-router-dom";

const StickyBottomButton = ({
  action,
  page,
  titleText,
  btnText,
  errors,
  disbaledBtn,
  children,
}) => {
  let disabled = errors && Object.values(errors).filter((item) => item);

  const { pathname } = useLocation();

  const isFullWidth = pathname.includes('fastCreateObject');
  const fullWidthClassName = useMemo(() => isFullWidth ? 'fullwidth' : '', [isFullWidth]);

  const buttons = themeButtons();

  if (children) {
    return <div className={`btn__sticky-bottom-toModal ${fullWidthClassName}`}>{children}</div>;
  }
  return (
    <div className={`btn__sticky-bottom-toModal ${fullWidthClassName}`}>
      {page === 'price' ? (
        <>
          <Button
            onClick={action}
            disabled={Boolean(disbaledBtn)}
            className={`btn ${buttons.btnGreen}`}
          >
            Редактировать {btnText}
          </Button>
          <h5 className='d-none d-lg-block'>{titleText}</h5>
        </>
      ) : (
        <>
          <Button
            disabled={disabled && disabled.length !== 0}
            onClick={action}
            className={`btn ${buttons.btnGreen}`}
          >
            {btnText ? btnText : 'Сохранить'}
          </Button>
          <h5 className='d-none d-lg-block'>{titleText}</h5>
        </>
      )}
    </div>
  );
};

export default StickyBottomButton;
